import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Stack, Card, CardHeader, CardContent, Typography, Collapse, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Alert } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { formatDateTime } from '../../../../../../services/functions';

function ParticipantDetail({ title, text }) {
  if (!text) {
    return null;
  }

  return (
    <Card sx={{ width: '48%', marginTop: '10px' }} >
      <CardHeader title={title} sx={{ mt: -1, mb: -2 }} />
      <CardContent>
        <Typography>{text}</Typography>
      </CardContent>
    </Card>
  );
}

function Row(props) {
  const { row, historic } = props;
  const [open, setOpen] = React.useState(false);
  const isEmpty = !historic
    ? !row.participant_diet && !row.participant_regular_medication && !row.participant_behavior && !row.participant_other_comments && !row.participant_siblings_and_friends && !row.comments
    : !row.uczestnik_dieta && !row.uczestnik_stale_leki && !row.uczestnik_zachowanie && !row.uwagi_dot_uczestnika;

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell align="left">{!historic ? row.identifier : row.idzamowienia__numer}</TableCell>
        <TableCell align="left">{!historic ? row.agreement_identifier : row.umowa}</TableCell>
        <TableCell align="left">{!historic ? formatDateTime(row.created_at) : formatDateTime(row.idzamowienia__data)}</TableCell>
        <TableCell align="left">{historic ? 'Tak' : 'Nie'}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box>
              {isEmpty
                ? <Alert severity="info">Brak danych</Alert>
                : !historic
                  ? <Stack direction="row" justifyContent="space-between" flexWrap="wrap" >
                    <ParticipantDetail title="Dieta uczestnika" text={row.participant_diet}/>
                    <ParticipantDetail title="Stałe leki uczestnika" text={row.participant_regular_medication}/>
                    <ParticipantDetail title="Zachowanie uczestnika" text={row.participant_behavior}/>
                    <ParticipantDetail title="Inne uwagi dotyczące uczestnika" text={row.participant_other_comments} />
                    <ParticipantDetail title="Rodzeństwo/Przyjaciele" text={row.participant_siblings_and_friends}/>
                    <ParticipantDetail title="Uwagi" text={row.comments}/>
                  </Stack>
                  : <Stack direction="row" justifyContent="space-between" flexWrap="wrap" >
                    <ParticipantDetail title="Dieta uczestnika" text={row.uczestnik_dieta}/>
                    <ParticipantDetail title="Stałe leki uczestnika" text={row.uczestnik_stale_leki}/>
                    <ParticipantDetail title="Zachowanie uczestnika" text={row.uczestnik_zachowanie}/>
                    <ParticipantDetail title="Inne uwagi dotyczące uczestnika" text={row.uwagi_dot_uczestnika} />
                  </Stack>
              }

            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}


const ParticipantDataFromOtherOrders = () => {
  const { order } = useSelector(state => state.orderData);

  return (
    <Card>
      <CardHeader title="Dane z innych zamówień" sx={{ mt: -1, mb: -2 }} />
      <CardContent>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell align="left">Numer zamówienia</TableCell>
                <TableCell align="left">Numer umowy</TableCell>
                <TableCell align="left">Data zamówienia</TableCell>
                <TableCell align="left">Dane historyczne</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {order.participant_data_from_other_orders.map(row => (
                <Row key={row.id} row={row} historic={false}/>
              ))}
              {order.participant_data_from_historic_orders.map(row => (
                <Row key={row.idind_sunsp_zamowienia} row={row} historic={true}/>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};


export default ParticipantDataFromOtherOrders;
